function initGsap() {
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

    // ScrollSmoother intercepts all touch events and re-implements scrolling via JS
    // transforms, which destroys mobile performance. Desktop only.
    if (window.matchMedia('(min-width: 750px) and (hover: hover)').matches) {
        ScrollSmoother.create({
            smooth: 0.8,
            effects: true,
        });
    }

    // Defer ScrollTrigger's automatic refresh so it doesn't block the main
    // thread immediately after load (avoids long tasks blocking scroll input).
    ScrollTrigger.config({ autoRefreshEvents: 'visibilitychange,DOMContentLoaded,load,resize' });

    // Header Scroll Animation
    const mm = gsap.matchMedia();
    mm.add("(min-width: 750px)", () => {
        const target = document.querySelector('.header__columns:has(header-menu)');

        if (target) {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: document.body,
                    start: "top top",
                    end: 200,
                    scrub: true,
                }
            });

            tl.to(target, {
                marginLeft: "var(--page-margin)",
                marginRight: "var(--page-margin)",
                paddingLeft: "1rem",
                paddingRight: "1rem",
                marginTop: "5px",
                borderRadius: "5px",
                ease: "power1.out",
                duration: 1
            }, 0);

            tl.to(target, {
                backdropFilter: "blur(66px)",
                webkitBackdropFilter: "blur(66px)",
                ease: "power1.out",
                duration: 1
            }, 0.5);
        }
    });

    // Dynamic Header Color Inversion
    const headerComponent = document.querySelector('header-component');
    if (headerComponent) {
        const invertSections = gsap.utils.toArray('.js-invert-header');

        invertSections.forEach((sec) => {
            ScrollTrigger.create({
                trigger: sec,
                start: () => `top ${headerComponent.offsetHeight / 2}px`,
                end: () => `bottom ${headerComponent.offsetHeight / 2}px`,
                onEnter: () => headerComponent.classList.add('header--inverse'),
                onLeave: () => headerComponent.classList.remove('header--inverse'),
                onEnterBack: () => headerComponent.classList.add('header--inverse'),
                onLeaveBack: () => headerComponent.classList.remove('header--inverse'),
                invalidateOnRefresh: true
            });
        });
    }
}

window.addEventListener('load', () => {
    initGsap();
    document.body.classList.add('gsap-ready');
});
